import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./App.css";
import Header from "./components/scripts/generals/header";
import Home from "./components/scripts/body_comps/home";
import AdminDashboard from "./components/scripts/admins/dashboard";
import MyToast from "./components/scripts/generals/my_toast";
import AddFood from "./components/scripts/admins/foods/add_food";
import AddRooms from "./components/scripts/admins/rooms/add_rooms";
import AdminRooms from "./components/scripts/admins/rooms/rooms";
import BookRoom from "./components/scripts/admins/rooms/book_room";
import AdminFoods from "./components/scripts/admins/foods/foods";
import CheckoutPage from "./components/scripts/admins/rooms/check_out";
import AdvanceBooking from "./components/scripts/admins/rooms/advance_book";
import Reports from "./components/scripts/admins/reports";
import AdvanceBookingHistory from "./components/scripts/admins/rooms/adv_book_history";
import AddStaff from "./components/scripts/admins/add_staff";
import Reprint from "./components/scripts/admins/reprint";
import EditBooking from "./components/scripts/admins/rooms/edit_booking";
import PageNotFound from "./components/scripts/body_comps/page_not_found";
import Logout from "./components/scripts/body_comps/logout";
import EditSelfDetails from "./components/scripts/admins/edit_self";
import BillEditor from "./components/scripts/admins/bill-editor";
import MyLoader from "./components/scripts/generals/my_loading";
import BookMultiRoom from "./components/scripts/admins/rooms/book_multiroom";
import Staff from "./components/scripts/admins/staff/staff";
import SettlementReport from "./components/scripts/admins/settlementReport";
import Sidebar from "./components/scripts/body_comps/sidebar";
import DailyTrack from "./components/scripts/admins/dailyTrack";
import DueHistory from "./components/scripts/admins/dueHistory";
import PurchaseBill from "./components/scripts/admins/foods/purchase_bill";

function App() {
  const [showToast, setShowToast] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const [toastColor, setToastColor] = useState("#4CAF50");
  const [toastMsg, setToastMsg] = useState("Message");

  const clientIs = localStorage.getItem("client_is");
  const staffAs = localStorage.getItem("staff_as");
  // console.log(clientIs, staffAs);
  // localStorage.removeItem('client_is');
  const collapsed = false;

  const isLoggedIn = clientIs === null;
  const clientDetails = JSON.parse(clientIs);
  const staffDetails = staffAs ? JSON.parse(staffAs) : null;
  // console.log(clientDetails);

  const permissions = staffDetails?.permissions
    ? JSON.parse(staffDetails.permissions)
    : {};


  function handleToastData(data) {
    setShowToast(true);
    setToastColor(data.toastColor);
    setToastMsg(data.toastMsg);
    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  }

  function handleLoading() {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 15000);
  }

  function closeToast() {
    setLoading(false);
  }

  function closeLoading() {
    setLoading(false);
  }

  function toggleHeader() {
    setShowHeader(!showHeader);
  }

  return (
    <Router>
      <MyToast
        message={toastMsg}
        color={toastColor}
        show={showToast}
        onClose={closeToast}
      />

      <MyLoader show={loading} close={closeLoading} />


      {isLoggedIn ? (
        <>
          {showHeader && (
            <Header
              hasLogin={!isLoggedIn}
              logoImg={clientDetails ? clientDetails.image : null}
            />
          )}

          <Routes>
            <Route
              exact
              path="/"
              element={
                <Home
                  handleToast={handleToastData}
                  handleLoading={handleLoading}
                  closeLoading={closeLoading}
                />
              }
            ></Route>

            <Route exact path="*" element={<PageNotFound />}></Route>
          </Routes>
        </>

      ) : (
        <>
          <Sidebar clientDetails={clientDetails} logoImg={clientDetails ? clientDetails.image : null} handleToast={handleToastData} />

          <div className={`dashboard-sidebar-right ${collapsed ? "collapsed" : ""}`}>


            <Routes>
              <Route
                exact
                path="/"
                element={<AdminDashboard clientDetails={clientDetails} />}
              ></Route>

              <Route
                exact
                path="/admin/dashboard"
                element={<AdminDashboard clientDetails={clientDetails} handleToast={handleToastData} />}
              ></Route>

              <Route
                exact
                path="/admin/edit-self"
                element={
                  <EditSelfDetails
                    handleToast={handleToastData}
                    clientDetails={clientDetails}
                    handleLoading={handleLoading}
                    closeLoading={closeLoading}
                  />
                }
              ></Route>

              {(staffDetails === null || permissions.room) && (
                <>
                  <Route
                    exact
                    path="/admin/rooms"
                    element={
                      <AdminRooms
                        handleToast={handleToastData}
                        id={clientDetails.id}
                        handleLoading={handleLoading}
                        closeLoading={closeLoading}
                      />
                    }
                  ></Route>

                  <Route
                    exact
                    path="/admin/add-room"
                    element={
                      <AddRooms
                        handleToast={handleToastData}
                        id={clientDetails.id}
                        handleLoading={handleLoading}
                        closeLoading={closeLoading}
                      />
                    }
                  ></Route>

                  <Route
                    exact
                    path="/admin/book-room"
                    element={
                      <BookRoom
                        handleToast={handleToastData}
                        id={clientDetails.id}
                        handleLoading={handleLoading}
                        closeLoading={closeLoading}
                      />
                    }
                  ></Route>

                  <Route
                    exact
                    path="/admin/book-multiroom"
                    element={
                      <BookMultiRoom
                        handleToast={handleToastData}
                        id={clientDetails.id}
                        handleLoading={handleLoading}
                        closeLoading={closeLoading}
                      />
                    }
                  ></Route>

                  <Route
                    exact
                    path="/admin/edit-booking"
                    element={
                      <EditBooking
                        handleToast={handleToastData}
                        id={clientDetails.id}
                        handleLoading={handleLoading}
                        closeLoading={closeLoading}
                      />
                    }
                  ></Route>

                  <Route
                    exact
                    path="/admin/leave-room"
                    element={
                      <CheckoutPage
                        handleToast={handleToastData}
                        id={clientDetails.id}
                        toggleHeader={toggleHeader}
                        handleLoading={handleLoading}
                        closeLoading={closeLoading}
                        clientDetails={clientDetails}
                      />
                    }
                  ></Route>

                  <Route
                    exact
                    path="/admin/book-advance"
                    element={
                      <AdvanceBooking
                        handleToast={handleToastData}
                        id={clientDetails.id}
                        clientDetails={clientDetails}
                        toggleHeader={toggleHeader}
                        handleLoading={handleLoading}
                        closeLoading={closeLoading}
                      />
                    }
                  ></Route>
                  <Route
                    exact
                    path="/admin/advance-history"
                    element={
                      <AdvanceBookingHistory
                        handleToast={handleToastData}
                        id={clientDetails.id}
                        handleLoading={handleLoading}
                        closeLoading={closeLoading}
                      />
                    }
                  ></Route>
                </>
              )}


              {(staffDetails === null || permissions.dailyTrack) && (
                <>
                  <Route
                    exact
                    path="/admin/daily-track"
                    element={
                      <DailyTrack handleToast={handleToastData} id={clientDetails.id} handleLoading={handleLoading}
                        closeLoading={closeLoading} />
                    }
                  ></Route>
                </>
              )}


              {(staffDetails === null || permissions.food) && (
                <>
                  <Route
                    exact
                    path="/admin/foods"
                    element={
                      <AdminFoods handleToast={handleToastData} id={clientDetails.id} />
                    }
                  ></Route>

                  <Route
                    exact
                    path="/admin/add-food"
                    element={
                      <AddFood
                        handleToast={handleToastData}
                        id={clientDetails.id}
                        handleLoading={handleLoading}
                        closeLoading={closeLoading}
                      />
                    }
                  ></Route>

                </>
              )}


              {(staffDetails === null || permissions.purchase) && (
<>
                  <Route
                    exact
                    path="/admin/purchase-bill"
                    element={
                      <PurchaseBill
                        handleToast={handleToastData}
                        id={clientDetails.id}
                                                toggleHeader={toggleHeader}
                        handleLoading={handleLoading}
                        closeLoading={closeLoading}
                      />
                    }
                  ></Route>



</>
              )}


              {(staffDetails === null || permissions.report) && (
                <>
                  <Route
                    exact
                    path="/admin/reports"
                    element={
                      <Reports
                        handleToast={handleToastData}
                        id={clientDetails.id}
                        handleLoading={handleLoading}
                        closeLoading={closeLoading}
                        toggleHeader={toggleHeader}
                      />
                    }
                  ></Route>

                </>
              )}

              {(staffDetails === null || permissions.due) && (
<>
                                    <Route
                    exact
                    path="/admin/due-history"
                    element={
                      <DueHistory
                        handleToast={handleToastData}
                        id={clientDetails.id}
                        handleLoading={handleLoading}
                        closeLoading={closeLoading}
                        toggleHeader={toggleHeader}
                      />
                    }
                  ></Route>
</>
              )}

              {(staffDetails === null || permissions.edit) && (

                <Route
                  exact
                  path="/admin/editor-bill"
                  element={
                    <BillEditor
                      handleToast={handleToastData}
                      id={clientDetails.id}
                      handleLoading={handleLoading}
                      closeLoading={closeLoading}
                    />
                  }
                ></Route>
              )}

              <Route
                exact
                path="/admin/add-staff"
                element={
                  <AddStaff
                    handleToast={handleToastData}
                    id={clientDetails.id}
                    handleLoading={handleLoading}
                    closeLoading={closeLoading}
                  />
                }
              ></Route>


              <Route
                exact
                path="/admin/staff"
                element={
                  <Staff
                    handleToast={handleToastData}
                    id={clientDetails.id}
                    handleLoading={handleLoading}
                    closeLoading={closeLoading} />
                }
              ></Route>

              <Route
                exact
                path="/admin/reprint"
                element={
                  <Reprint
                    handleToast={handleToastData}
                    id={clientDetails.id}
                    clientDetails={clientDetails}
                    toggleHeader={toggleHeader}
                  />
                }
              ></Route>

              {(staffDetails === null || permissions.settlement ) && (
              <Route
                exact
                path="/admin/settlement-report"
                element={
                  <SettlementReport
                    handleToast={handleToastData}
                    id={clientDetails.id}
                    handleLoading={handleLoading}
                    closeLoading={closeLoading}
                  />
                }
              ></Route>
              )}


              <Route
                exact
                path="/admin/logout"
                element={
                  <Logout handleToast={handleToastData} id={clientDetails.id} />
                }
              ></Route>

              <Route exact path="*" element={<PageNotFound />}></Route>
            </Routes>
          </div>
        </>
      )}

      {/* <Footer /> */}
    </Router>
  );
}

export default App;
